import React, {Component} from 'react';
import Menu from "../components/Menu";
import Axios from "axios";
import ApiUrl from "../AppUrl/ApiUrl";
import {toast} from "react-toastify";

class AddPackage extends Component {
    constructor() {
        super();
        this.state = {
            name: "",
            spin: "",
            ads: "",
            amount: "",
            token: ""
        }
    }

    componentDidMount() {
        var token = localStorage.getItem("admintoken");
        this.setState({ token: token });
    }

    onChangeInput = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmitForm = (event) => {
        event.preventDefault();
        var val = this.state;

        var formData = new FormData();
        formData.append("token", val.token);
        formData.append("name", val.name);
        formData.append("spin", val.spin);
        formData.append("ads", val.ads);
        formData.append("amount", val.amount);

        Axios.post(ApiUrl.baseurl + "plan/add", formData)
            .then(res => {
                if(res.data.success || res.status === 201) {
                    toast.success(res.data.success || "Plan added successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTimeout(
                        () => this.props.history.push(`/package`),
                        300
                    );
                } else {
                    toast.error(res.data.error || "Something went wrong", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(error => {
                console.log(error);
                toast.error(error.response?.data?.error || "Server error occurred");
            });
    }

    render() {
        return (
            <Menu title="Add New Package">
                <h3 className="bg-white title-head"> Add Package </h3>
                <div className="container-fluid currency-add">
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={this.onSubmitForm}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label>Plan Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            required
                                            value={this.state.name}
                                            onChange={this.onChangeInput}
                                            className="form-control shadow-none"
                                            placeholder="Enter plan name"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Spin Count</label>
                                        <input
                                            type="text"
                                            name="spin"
                                            required
                                            value={this.state.spin}
                                            onChange={this.onChangeInput}
                                            className="form-control shadow-none"
                                            placeholder="Enter spin limit"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Ads Count</label>
                                        <input
                                            type="text"
                                            name="ads"
                                            required
                                            value={this.state.ads}
                                            onChange={this.onChangeInput}
                                            className="form-control shadow-none"
                                            placeholder="Enter ads limit"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Amount</label>
                                        <input
                                            type="text"
                                            name="amount"
                                            required
                                            value={this.state.amount}
                                            onChange={this.onChangeInput}
                                            className="form-control shadow-none"
                                            placeholder="Enter package amount"
                                        />
                                    </div>
                                    <div className="col-md-12 mt-4 mb-5">
                                        <button type="submit" className="btn btn-primary shadow-none">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default AddPackage;